enum TRANSFER_TYPE {
  default,
  internalTransfer,
  domesticTransfer,
  billPayee,
  internationalTransfer,
  bulk
}

export default TRANSFER_TYPE;
